export const ContactData = {
    phneNumber: '22 116 82 96',
    email: 'info@nocowanie.pl',
};
